import {BrandSubscriptionNotification} from '../notifications/emails/entities/brand-subscription/constants'

export const BRAND_SUBSCRIPTION_PAYMENT_MAX_NUMBER_OF_ATTEMPTS = 4

export enum BrandSubscriptionStatus {
  created = 'Created',
  trialStarted = 'Trial started',
  subscriptionStarted = 'Subscription started',
  subscriptionCancelled = 'Subscription cancelled',
  abandoned = 'Abandoned',
}

export const brandSubscriptionCancelledStatuses = [
  BrandSubscriptionStatus.subscriptionCancelled,
  BrandSubscriptionStatus.abandoned,
]

export enum BrandSubscriptionTrackingActionId {
  cancel = 'cancel',
}

export enum BrandSubscriptionAction {
  platformsChanged = 'Platforms changed',
  paymentMethodChanged = 'Payment method changed',
  upcomingPaymentNotification = 'Upcoming payment notification',
  paid = 'Paid',
  paymentDeclined = 'Payment declined',
  trialResultNotViewedNotification = 'Trial result not viewed notification',
  trialResultEmptyNotification = 'Trial result empty result notification',
  trialResultNotOrderedNotification = 'Trial result not ordered notification',
  trialResultOrderedNotification = 'Trial result ordered notification',
  checkoutCompleted = 'Checkout completed',
}

export enum BrandSubscriptionPaymentFrequency {
  monthly = 'monthly',
  yearly = 'yearly',
}

export const brandSubscriptionPaymentFrequencyToNumber = {
  [BrandSubscriptionPaymentFrequency.monthly]: 1,
  [BrandSubscriptionPaymentFrequency.yearly]: 12,
}

export enum BrandSubscriptionTier {
  v1Trial = 'v1-trial',
  v1Active = 'v1-active',
  v2Essential = 'v2-essential',
  v2Advanced = 'v2-advanced',
  v2AdvancedEnforcement = 'v2-advanced-enforcement',
}

export enum BrandSubscriptionPlatform {
  amazon = 'amazon',
  googleAds = 'google_ads',
  facebook = 'facebook',
  instagram = 'instagram',
  ebay = 'ebay',
  businessRegisters = 'business_registers',
  trademarkRegisters = 'trademark_registers',
  webDomains = 'web_domains',
  aliExpress = 'aliexpress',
  appStore = 'app_store',
  googlePlay = 'google_play',
  youtube = 'youtube',
  etsy = 'etsy',
  tiktok = 'tiktok',
  temu = 'temu',
  fruugo = 'fruugo',
  shopify = 'shopify',
  walmart = 'walmart',
}

// Platforms we don't monitor but have a brand protection guide for.
export enum NotOfferedBrandSubscriptionPlatform {
  twitterX = 'twitter_x',
}

export const brandSubscriptionPlatformsPricedPerItem: string[] = [
  BrandSubscriptionPlatform.amazon,
  BrandSubscriptionPlatform.googleAds,
]

export const YEARLY_PAYMENT_DISCOUNT_PERCENTAGE = 20

export const brandSubscriptionStatusToNotification: Partial<
  Record<BrandSubscriptionAction | BrandSubscriptionStatus, BrandSubscriptionNotification>
> = {
  [BrandSubscriptionStatus.subscriptionCancelled]:
    BrandSubscriptionNotification.subscriptionCancelled,
  [BrandSubscriptionAction.checkoutCompleted]: BrandSubscriptionNotification.orderConfirmation,
}
